import { ReactElement, ReactNode, CSSProperties, memo } from 'react'
import PropTypes from 'prop-types'

import { ReactComponent as CheckIcon } from '@/svg/check.svg'

import Container from './style'

interface Props {
  children: ReactNode | string
  style?: CSSProperties
  className?: string
  id?: string
}

function Checked({ id, children, className, style }: Props): ReactElement {
  return (
    <Container id={id} className={className} style={style}>
      <CheckIcon />
      <section>{children}</section>
    </Container>
  )
}

Checked.propTypes = {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.string])
    .isRequired,
  style: PropTypes.object,
  className: PropTypes.string,
  id: PropTypes.string,
}

Checked.defaultProps = {
  className: '',
}

export default memo(Checked)
